import axios from 'axios'

export const genericEdit = (id: string | null | undefined, type: 'narrative' | 'community' | 'tag', value: string) => {
  return axios.patch(`/${type}/${id}`, [{ op: 'replace', path: '/label', value }])
}
